import React, { useEffect, useState } from "react";
import "./index.css";
import Icons from "../../../../../components/ui/Icons";
import { getCurrentLang } from "../../../../../config/commonUtil";

/**
 * description
 * title: Accordion的title ,
 * children: 折叠区域的内容
 * foldState折叠状态,默认true
 * className 自定义 传入一个class
 * toggleContentVisibility：点击出现折叠区域，放在盒子的最外层。
 */
const Accordion = (props) => {
  const { title, children, foldState, className, lock = false,href,url  } = props;

  const lang = getCurrentLang();
  const [isContentVisible, setIsContentVisible] = useState(foldState);
  const toggleContentVisibility = (e) => {
    e.stopPropagation();
    if (lock === false) {
      // e.preventDefault();
      setIsContentVisible(!isContentVisible);
    }
  };

  useEffect(() => {
    setIsContentVisible(foldState)
  },[foldState])

  //   icon
  const downLine = <Icons type="rightLine" customClassName="upLineIcon" />;
  const upLine = <Icons type="downLine" customClassName="upLineIcon" />;

  return (
    <div className={`bx-menu-accordion ${className}`} >
      {/* 头部 */}
   
      <div className="bx-menu-accordion-header" onClick={toggleContentVisibility} >
        {href ? <a href={href}  className={`title`}> {title} </a> : <div className={`title`}>{title}</div>}
        {lock === false && <div className="right aia-bx-flex" >
          {isContentVisible ? upLine : downLine}
        </div>}
      </div>
      {/* 内容区域 */}
      <div
        className={`bx-menu-accordion-content ${isContentVisible ? "content-visible" : "content-hidden"
          }`}
      >
        {<>{children}</>}
      </div>
    </div>
  );
};
Accordion.defaultProps = {
  title: "默认titie",
  children: undefined,
  icon: <Icons type="downLine" customClass="upLineIcon" />,
  foldState: false,
  className: "",
  lock: false,
  url:"",
};
export default Accordion;
